var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.152,
    height: 34.81,
    viewBox: "0 0 22.152 34.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#33233d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-108 -487.19)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.582,21.165h3.165a1.582,1.582,0,0,0,0-3.165H11.582a1.582,1.582,0,0,0,0,3.165Z",
    transform: "translate(105.911 496.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.152,5.747A4.749,4.749,0,0,0,22.4,1H9.747A4.749,4.749,0,0,0,5,5.747V31.063A4.749,4.749,0,0,0,9.747,35.81H22.4a4.749,4.749,0,0,0,4.747-4.747Zm-3.165,0V31.063A1.583,1.583,0,0,1,22.4,32.645H9.747a1.583,1.583,0,0,1-1.582-1.582V5.747A1.583,1.583,0,0,1,9.747,4.165H22.4a1.583,1.583,0,0,1,1.582,1.582Z",
    transform: "translate(103 486.19)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M104.7,5.949a.547.547,0,0,1-.547.547h-3.573a.547.547,0,0,1,0-1.094h3.573A.547.547,0,0,1,104.7,5.949Z",
    transform: "translate(16.705 487.19)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.28f38937e63a89ab13b09f54aeb29808.svg";
export { ForwardRef as ReactComponent };